import { CardSvg } from '@/play/cardSvg'

/** Home card art for Ooze pen: a sheet on a table with neon goo lines drawn on it (no text). */
export function OozePenCardArt() {
  return (
    <CardSvg bg="#c8b89e">
      <path d="M40 40 L 280 40 L 300 180 L 20 180 Z" fill="#f6f4ee" />
      <path d="M60 140 C 90 70, 130 70, 150 120 S 210 160, 250 80" stroke="#6dff3a" strokeWidth="10" strokeLinecap="round" fill="none" />
      <path d="M70 80 C 120 100, 180 60, 230 140" stroke="#ff3fb4" strokeWidth="10" strokeLinecap="round" fill="none" />
      <circle cx="250" cy="80" r="11" fill="#6dff3a" />
      <path d="M62 136 C 90 76, 126 74, 146 114" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.55" />
    </CardSvg>
  )
}
